import Vue from "vue";

// UI Frameworks
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Device Detection
import device from "vue-device-detector-js"; // Doc: https://www.npmjs.com/package/vue-device-detector-js

// Sweet Alert
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

// Date/Time Components
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { Settings } from "luxon";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/th";

// Form Components
import Multiselect from "vue-multiselect";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import Vuelidate from "vuelidate";

// Canvas/Drawing
import VueKonva from "vue-konva";

// HTTP Client
import VueAxios from "vue-axios";
import { axios } from "@/config/axios";

// Utils
import utilsPlugin from "@/utils/utilsPlugin";
import { formatPrice } from "@/utils/utils";
import store from "@/store";

const installPlugins = () => {
  // Phase 1C: permission helper. Use as $can('user.assign.MANAGER', { branchId }).
  Vue.prototype.$can = function (permKey, ctx) {
    return store.getters["moduleUser/can"](permKey, ctx);
  };

  // สิทธิ์เพิ่ม/แก้/ลบ master list — ใช้เป็น $canManageMasterData() ใน template
  Vue.prototype.$canManageMasterData = function () {
    return store.getters["moduleUser/canManageMasterData"];
  };

  // Bootstrap Vue
  Vue.use(BootstrapVue);
  Vue.use(IconsPlugin);

  // Device Detection
  Vue.use(device);

  // Sweet Alert
  Vue.use(VueSweetalert2);

  // Date/Time
  Vue.use(Datetime);
  Settings.defaultLocale = "th";

  // Form Validation
  Vue.use(Vuelidate);

  // Canvas/Drawing
  Vue.use(VueKonva);

  // HTTP Client
  Vue.use(VueAxios, axios);

  // Utils
  Vue.use(utilsPlugin);

  // Number formatting filter
  Vue.filter("comma", formatPrice);

  // Global Components
  Vue.component("datetime", Datetime);
  Vue.component("multiselect", Multiselect);
  Vue.component("vue-typeahead-bootstrap", VueTypeaheadBootstrap);
  Vue.component("date-picker", DatePicker);
};

export default installPlugins;